import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgQrCode = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M9 9v2h2m.667-2h2m0 2.667h-2v2m-2.667 0V13M5.667 2.333h-2c-.737 0-1.334.597-1.334 1.334v2C2.333 6.403 2.93 7 3.667 7h2C6.403 7 7 6.403 7 5.667v-2c0-.737-.597-1.334-1.333-1.334M3.667 9h2C6.403 9 7 9.597 7 10.333v2c0 .737-.597 1.334-1.333 1.334h-2a1.333 1.333 0 0 1-1.334-1.334v-2C2.333 9.597 2.93 9 3.667 9m6.666-6.667h2c.737 0 1.334.597 1.334 1.334v2c0 .736-.597 1.333-1.334 1.333h-2A1.333 1.333 0 0 1 9 5.667v-2c0-.737.597-1.334 1.333-1.334"
	})
});
export default SvgQrCode;
